import React from "react";
import DatePicker from "react-datepicker";

export default function ComplaintDateField({
  id,
  label,
  required,
  error,
  value,
  onChange,
  placeholder,
}) {
  return (
    <div className="form-group form-date">
      <label htmlFor={id}>
        {required ? <span>*</span> : null}
        {label}
      </label>
      <div className="validation-cover">
        <DatePicker
          id={id}
          selected={value}
          onChange={(nextValue) => onChange(nextValue)}
          dateFormat="MMMM dd, yyyy"
          placeholderText={placeholder}
          className={`form-control ${error ? "is-invalid" : ""}`}
          autoComplete="off"
          maxDate={new Date()}
          showPopperArrow={false}
        />
      </div>
    </div>
  );
}
